import {useState} from 'react'
import {VideoForm, VideoIconButton, FollowButton} from '../../generics'


const BandDetailMainButton = ({ bandId, isOwner }) => {
  const [open, setOpen] = useState(false)


  const handleClose = () => {
    setOpen(false)
  }


  return isOwner ? (
    <VideoIconButton open={open} setOpen={setOpen}>
      <VideoForm id={bandId} type='band' close={handleClose} />
    </VideoIconButton>
  ) : (
    <FollowButton id={bandId} type='band' />
  )
}


export default BandDetailMainButton